/**
 * Define application level constants here
 */

// import file from './../../public/urlConfig.json'

// configure following two constants before creating build file

const isProduction = true; //true ? PRODUCTUION URL :  LOCAL URL
const usedByQA = false; // true ? ports used(7092, 7081) :  ports used(9092, 8081)
// console.log('run', window.runtimeUrlConfig)
// URL CONFIG
const LOCAL_RAW_URL = "192.168.1.214:";
const PRODUCTION_RAW_URL = "rdpms.in:";
const RAW_URL = isProduction ? PRODUCTION_RAW_URL : LOCAL_RAW_URL;
// PORTS CONFIG
const basePort = usedByQA ? "443/edge" : "9092/edge";
const baseSocketPort = usedByQA ? "7084" : "8084";
const alarmPort = usedByQA ? "7081/alarm_api" : "8081/alarm_api";
const alarmSocketPort = usedByQA ? "7081/alarm_api/api/v2/stream/alarm" : "8081/alarm_api/api/v2/stream/alarm";

//
const default_geo_server_conf = {
    url: "http://68.178.175.37:8080/geoserver/geonet/ows",
    map_tiles_config: {
      maxZoom: 20,
      custome_tile_options: {
        url: "https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}",
        query: {
          access_token: "pk.eyJ1Ijoicm9jb2RlNDUiLCJhIjoiY21ieW5pejFxMWZxNzJqczF3MzJtYnluZyJ9.0gLTZx5QXBOBYCFg9h4mrA",
        },
        other_opts: { tileSize: 512, zoomOffset: -1 },
      },
    },
    tile_layer_url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    tile_layer_options: {
      attribution: "Tiles © Esri",
    },
  };
const default_fams_api_configuration ={
    url : 'http://68.178.175.37:9051'
  }
const urlConfigFile = window.runtimeUrlConfig;
const {
  url,
  base_api_configurations,
  alarm_api_configurations,
  geo_server_configuration = default_geo_server_conf,
  fams_api_configuration= default_fams_api_configuration,
  fams_app_url=''
} = urlConfigFile;

export const app_config = {
  url, 
  base_api_configurations,
  alarm_api_configurations,
  geo_server_configuration: geo_server_configuration ?? default_geo_server_conf,
  fams_api_configuration: fams_api_configuration ?? default_fams_api_configuration,
  fams_app_url:fams_app_url ?? 'http://68.178.175.37:8080/GeoNETNg/#/'
}
// Per-section hosts for subdomain routing (Caddy). Each falls back to the
// top-level `url` so single-domain deploys keep working unchanged.
const base_rest_host = base_api_configurations.url ?? url;
const base_ws_host = base_api_configurations.websocket_url ?? url;
const alarm_host = alarm_api_configurations.url ?? url;

const edge_base_api_prefix = "/edge/api";
const edge_base_websocket_prefix = "/edge/wss";
const edge_alarm_api_prefix = "/alarm_api/api/v2";
const edge_scheduled_report_api_prefix = "/report_api/api";
const edge_alarm_notification_api_prefix = "/notification_api/api/v1";
const trend_api_prefix = "/trend_api/api";
const pcdo_api_prefix = "/pcdo_api";

// export const APP_BASE_URL1 = base_api_configurations.api_protocol + url + base_api_configurations.api_port;
export const APP_BASE_URL =
  base_api_configurations.api_protocol + base_rest_host + base_api_configurations.api_port + edge_base_api_prefix;
export const APP_GEO_SERVER_URL = geo_server_configuration.url;
export const FAMS_API_URL = fams_api_configuration.url;
export const APP_BASE_URL_SOCKET =
  base_api_configurations.websocket_protocol +
  base_ws_host +
  base_api_configurations.websocket_port +
  edge_base_websocket_prefix;
export const APP_BASE_URL_ALARM =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + edge_alarm_api_prefix;
export const APP_BASE_URL_SCHEDULED_REPORT =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + edge_scheduled_report_api_prefix;
export const GENRIC_ATTACHMENT_VIEW_URL =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + "/alarm_api/api/v2";
export const APP_BASE_URL_ALARM_SOCKET =
  alarm_api_configurations.websocket_protocol + alarm_host + alarm_api_configurations.api_port + edge_alarm_api_prefix;
export const APP_BASE_URL_NOTIFICATIONS =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + edge_alarm_notification_api_prefix;
export const APP_BASE_URL_TREND =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + trend_api_prefix;

export const LAYOUT_PLAYBACK_URL =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + "/edge_playback/api/simulate";

export const APP_BASE_URL_PCDO =
  alarm_api_configurations.api_protocol + alarm_host + alarm_api_configurations.api_port + pcdo_api_prefix;
// Sidebar width
export const drawerWidth = 240;

//socketUrl
export const TELEMETRY_WEBSOCKET = "/edge/wss";
export const ALARM_WEBSOCKET_PATH = "/stream/alarm";
// export const NOTIFICATION_WEBSOCKET = "/notification_api"

// BASE APIS
export const LOGIN_API = "/user/login";
export const REFRESH_TOKEN_PATH = "/user/refreshToken";

//FAMS 
export const GET_AOI_FROM_STN = '/unprotected/aoi/stn'

export const MCDO_EMPLOYEE_BIODATA = "/v1/kolkata/employees";
export const MCDO_CADRE_STAFF_VACANCY = "/v1/kolkata/staffvacancy";
export const MCDO_TARGET_HIGHLIGHTS = "/v1/kolkata/targetHighlights";
export const MCDO_STAFF_INSPECTION = "/v1/kolkata/staffInspections";
export const MCDO_DRAWING_POSITION = "/v1/kolkata/drawingpositions";
export const MCDO_SELECTION_CALENDER = "/v1/kolkata/selectionCalender";
export const MCDO_AMC = "/v1/kolkata/amc";
export const MCDO_PRIME_AGENDA = "/v1/kolkata/primeAgenda";
export const EMPLOYEE_TRAVEL_ALLOWANCE = "/v2/kolkata/eta";
export const EMPLOYEE_CONTIGENT_AMOUNT = "/v2/kolkata/eta-contigent";
export const EMPLOYEE_TRAVEL_ALLOWANCE_EXPORT = EMPLOYEE_TRAVEL_ALLOWANCE + "/export";

export const GENERATE_OTP = "/user/login/generateOtp";
export const GET_DEVICE_BY_CUSTOMER_ID = "/devices/deviceTypes";
export const ACK_MAINTENANCE_PVT_ENTRY = "/devices/maintenanceRoaster/ackPredictiveEntry?";
export const GET_UNIVERSAL_DEVICE_KEYS = "/deviceKeys";
export const GET_UNIVERSAL_DEVICE_KEYS_ADD = "/deviceKeys/add";
export const ADD_USER = `/user`;
export const DELETE_USER = "/user/";
export const UPDATE_USER = "/user";
export const USER_PERMISSION = "/user/forentend/permission";
export const ACTIVATE_DEACTIVATE_USER = "/user/update-active-inactive";
export const RESET_PASSWORD = "/user/password/reset?";
export const PRELOAD_YARDVIEW = "/devices/telemetry/svg";
export const GET_ROSTER_DATA_BY_ID = "/devices/maintenanceRoaster";

/** Document Management */
export const GET_DOCUMENTS = "/document/paginated";
export const DOCUMENTS_PATH = "/document";

/** Circular Policy Management */
export const GET_CIRCULAR_POLICY = "/circular_policy/paginated";
export const CIRCULAR_POLICY_PATH = "/circular_policy";

/** CUSTOMER CONTROLLER */
export const CUSTOMER_ENDPOINT = "/customer";
export const PLATFORM_SVG_FOR_STATION = "/customer/sgv";

// SCHEDULED REPORTS
export const SCHEDULED_REPORT_TYPES = "/generic/enums/report_type";
export const SCHEDULED_REPORT_FREQUENCY = "/generic/enums/report_frequency";
export const SCHEDULED_REPORT_TEMPLATES = "/template";
export const SCHEDULED_REPORT_SUBSCRIPTIONS = "/subscription";

// TMMS Dashboard
export const GET_ALL_ASSETS = "/allAssets";
export const GET_MAINTENANCE_SCHEDULE = "/maintenanceSchedule";
export const GET_ASSET_HEALTH = "/assetHealth";
export const GET_ALL_COUNTS_TMMS_DASHBOARD = "/mistamsdashboard/all-counts";

/* customers */
export const GET_ALL_CUSTOMER = "/customer";

/** History */
export const GET_TELEMETRY_HISTORY = "/history/timeseries";
export const GET_TELEMETRY_HISTORY_BY_TIMESTAMP_WITH_KEYS = "/history/timeseries/keys";
export const EXPORT_HISTORY = "/history/export";
export const GET_LAST_ENTRY_TS = "/history/lastDeviceEntry";
export const GET_CABLE_MONITORING_HISTORY = "/history/cablemonitor/timeseries";

/**DFCCIL dashboard api */
export const SFR_CHART_CHAIN_API = "/v2/failureReports/search";
export const MAINTENACE_CHART_CHAIN_API = "/v2/maintenanceTask/counts";

/*user*/
export const GET_ALL_USER = "/user";
export const GET_ALERTS_HISTORY = "/alert/stats/";
export const ASSET_ACTIVE_DISABLE_API = "/devices";
/* assets*/
export const UPLOAD_MULTIPLE_ATTACHMENTS = "/v1/attachment/upload_multiple";
export const GET_ATTACHMENTS = "/v1/attachment";
export const GET_ATTACHMENT_BY_ID = "/v1/attachment/static";
export const DELETE_ATTACHMENT = "/v1/attachment";
export const GET_COLLECTION_MAP_ID = "/v1/collection_map";
export const GET_ASSET_FORM = "/v1/asset/form";
export const GET_LATEST_TELEMETRY = "/devices/telemetry";
export const GET_DEVICE_BY_ID = "/v1/device";

//SFR APIS
export const SFR_API = "/v1/failureReports";
//ASSET APIS
export const GET_DEVICE_TYPE_ASSET = "/v1/device_type";
export const GET_SYSTEM_CONFIGURATION = "/software";
export const ASSET_FORM = "/v1/device"; // post||put
export const ASSET_EXPORT = "/devices/export";
export const ASSET_COUNTS = "/v2/device/count"; // post||put
export const GET_ASSETS = "/v1/device";
export const GET_ASSETS_PAGINATED = "/v2/device";
export const DELETE_ASSET = "/v1/device/";
export const ASSET_ADDITIONAL_INFO = "/v1/response"; // get || post || put
export const RTU_CREDS_API = "/v1/device/";
export const ASSET_MAINTENANCE_TABLE_API = "/v1/maintenance/history";
export const ASSET_MAINTENANCE_HISTORY_API = "/v1/maintenance/device/history";
export const GET_UNIQUE_ASSET_CODE = "/v2/device/getUniqueAssetCode";
export const JSON_TYPES = "/v1/device/jsonTypes"; // used to get sub types of asset
//----------DROPDOWNS------
export const GET_USER_ROLES = "/dashboard/userRole";
export const GET_FORMS_LIST = "/dashboard/maintenanceForm";
export const GET_CUSTOMER_GROUP_LIST = "/dashboard/customerGroup";
export const GET_SCHEDULE_CODE_LIST = "/v1/maintenance/form/schedulecode";
export const GET_ASSET_LIST = "/dashboard/asset";
export const GET_USER_LIST = "/dashboard/user";
export const TRAIN_LIST_API = "/v1/trains/info";
export const SUB_DEVICES_PATH = "/v1/device/subDevices";

// JOINT INSPECTION
export const GET_MAINTENANCE_HISTORY = "/v2/kolkata/join-inspection/v1/maintenance/history";
export const GET_DEVICE_MAINTENANCE_HISTORY = "/v2/kolkata/join-inspection/v1/maintenance/device/history";

//asset transfer
export const GET_USER_ASSIGNED_ASSETS = `/v1/assetAssignments/asset/user/`;
export const DELETE_RECLAIM_ASSET_ASSIGNMENT = `/v1/assetAssignment/reclaimTransfer`;
export const POST_ASSET_ASSIGNMENT_TRANSFER = `/v1/assetAssignment/transfer`;

//-----asset replacement
export const ASSET_REPLACEMENT = "/v2/kolkata/asset_replacement";

//-----form assignment
export const FORM_ASSIGNMENT_API = "/v1/maintenance/form/schedule";
export const JOINT_INSPECION_ASSIGNMENT_API = "/v2/kolkata/join-inspection";
export const ASSET_ASSIGNMENT_API = "/v1/assetAssignment/asset/user/search";
export const POST_ASSET_ASSIGNMENT_API = "/v1/assetAssignments/asset/user";
export const DELETE_ASSET_ASSIGNMENT_API = "/v1/assetAssignments/asset";
export const MAINTENACE_FORM_API = "/v1/maintenance/form";
export const GET_CUSTOMER_GROUP = "/v1/maintenance/customerGroup";
export const POST_CUSTOMER_GROUP = "/v1/maintenance/customerGroup/create";
export const DELETE_CUSTOMER_GROUP = "/v1/maintenance/customerGroup/delete";
export const PUT_CUSTOMER_GROUP = "/v1/maintenance/customerGroup/update";
//----maintenance dropdowns----
export const GET_MAINTENANCE_COUNT = "/v1/maintenanceTask/counts";
export const GET_MAINTENACE_ASSET = `/v1/maintenanceTask`;
export const DASHBOARD_MAINTENANCE_ROSTER = `/v1/devices/maintenanceRoaster/overview`;

// Audit Controller
export const LOGIN_AUDIT = "/v1/loginAudit";

// Kavach Dashboard - ENMS Controller (uses v2 endpoint for nameLike filter support)
export const GET_KAVACH_EVENT_LOGS = "/v2/event_logs";

// SMPS Dashboard - ENMS Controller (uses v2 endpoint for nameLike filter support)
export const GET_SMPS_EVENT_LOGS = "/v2/event_logs";
export const GET_SNMP_TRAPS = "/v2/enms/traps";

// ALARM_APIS
export const GENERIC_BASE_PATH = "/generic";
export const PACKET_PARAM = GENERIC_BASE_PATH + "/packet_parma";
export const FMEA_RELATION = GENERIC_BASE_PATH + "/fmea_relation";
//-----dashboards---
export const GROUP_BY_COUNT_API = "/alarm/group_by_count";
/** ALARMS APIs */
export const GET_PAGINATED_ALARMS = `/alarm/paginated`;
export const GET_ACTIVE_ALARMS = `/alarm/active`;
export const GET_ALARM_TIMELINE = `/alarm/paginated`;
export const GET_GROUP_BY_COUNT = `/alarm/group_by_count`;
export const PATCH_ACK_ALARM = `/alarm/acknowledge`;
export const PATCH_CLEAR_ALARM = `/alarm/clear`;
export const GENERIC_ATTACHMENTS = `/generic/attachment`;
export const GET_ALARM_BY_ID = "/alarm/";
export const SYSTEM_ALARMS = "/alarm/customer_software_status";

/** Rules APIs */
export const GET_RULES = `/rule`;
export const POST_RULE = `/rule`;
export const PUT_RULE = `/rule/`;
export const DELETE_RULE = `/rule/`;
export const COPY_RULES = `/rule/batch_copy`;

/** Utilisation APIs */
export const PM_UTILISATION = "/utilisation/pm_summary";
export const TC_UTILISATION = "/utilisation/tc_summary";

/** Notifications - Firebase Cloud Messaging(FCM) */
export const ALARM_NOTIFICATION = "/frontend/notification";
export const NOTIFICATION_COUNT = "/frontend/notification/count";
export const MARK_NOTIFICATION = "/frontend/notification/mark";
export const NOTIFICATION_USER_MEDIUM = "/frontend/notification/user_medium";
export const REGISTER_USER = "/frontend/fcm/register";
export const UNREGISTER_USER = "/frontend/fcm/unregister";
/** Generic APIs */
export const GENERIC_ATTACHMENT = `/generic/attachment`; //get|post|delete
export const GENERIC_DEVICE_CONNECTIONS = "/generic/device_connection";
export const RTU_HEALTH = "/generic/rtu_health";
export const RTU_HEALTH_STATUS = "/generic/rtu_health_status";
export const DISTINCT_STATIC_TYPE = "/generic/distinct_static_type"

export const GET_TREND_FEATURE = "/trend/features"; // get list of features (each row represents one trend feature)
export const GET_TREND_FEATURE_FOR_GRAPH = "/trend/paginated"; //get get each features data point (for each day and device and feature one row is there)
export const GET_TREND_HISTORY = "/trend/paginated/feat_agg"; //to get history of trends features (for each day and device one row is there)
export const GET_TREND_LATEST = "/trend/paginated/feat_agg/latest"; //to get latest trend of all devices (for each device one row is there)

export const LOGOUT_URL = "/user/logout";

// MIS REPORTS
export const ASSET_CODAL_EXPIRE = "/v2/kolkata/asset-codal-expire";
export const SFR_REPORTS = "/v1/failureReports";
export const UNHEALTHY_ASSET_REPORT = "/v2/kolkata/unhealthy-asset-report";

// export const GET_ALL_DEVICES_API = "/api/v2/devices/getAllDevices";
// export const GET_DEVICE_BY_USER_ID = "/api/devices/user/";
// export const ADD_DEVICE_API = "/api/v2/devices/add";
// export const GET_ALL_ALERTS = "/api/v2/alert/allActiveAlerts";
// export const GET_ALL_CUSTOMERS = "/api/v2/customer/getAllCustomers";
// export const DELETE_DEVICE = "/api/v2/devices/delete";
// export const ACK_ALARM = "/api/v2/alert/ackAlarm";
// export const EDIT_DEVICE = "/api/v2/devices/updateDeviceById";
// export const GET_DEVICE_TYPES = "/api/devices/getDeviceTypes";
// export const GET_DEVICE_TYPES_FOR_TABLE = "/api/devices/deviceKeys/deviceTypes"; //universal
// export const GET_DEVICE_KEYS = "/api/devices/deviceKeys";
// export const CREATE_RULE = "/rule";
// export const RULES_API = "/rule";
// export const UPDATE_RULES = "/rule";
// export const GET_RULE_TEMPLATE = "/rule/template";
// export const GET_USER_BY_ID = "/api/user/";
// export const GET_ACTIVE_ALERTS_BY_ID = "/alert/active?customers=";
// export const ACK_CLEAR_ALARM = "/alert/";
// export const UPLOAD_SINGLE_ATTACHMENT = "/api/v1/attachment/upload";
// export const NOTIFY_ASSETS_UPDATE = "/api/v2/generic/refresh_store?store=DEVICE";
// export const GET_TELEMETRY_HISTORY_BY_DEVICEID = "/api/history?devieId=";
// export const GET_TELEMETRY_HISTORY_BY_TIMESTAMP = "/api/history/timeseries?deviceId=";
// export const GET_ZONE = "/api/dashboard/railwayData";
// export const GET_DIVISION_BY_ZONE = "/api/dashboard/railwayData/zone";
// export const GET_STATION_BY_DIV = "/api/dashboard/railwayData/division";
// export const SUBMIT_ADDITIONAL_INFO_ASSET = "/api/v1/response?";

export const tsToDateTimeFormatter = {
  valueFormatter: (param: any) => {
    if (param.value && param.value > 0) {
      const value = Number(param.value);
      const date = new Date(value);
      const yyyy = date.getFullYear();
      let mm: any = date.getMonth() + 1; // Months start at 0!
      let dd: any = date.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedToday = dd + "/" + mm + "/" + yyyy;
      const time = date.toLocaleTimeString();
      // return formattedToday;
      return formattedToday + " " + time;
    } else {
      return "-";
    }
  },
};

export const tsToDateFormatter = {
  valueFormatter: (param: any) => {
    if (param.value && param.value > 0) {
      const value = Number(param.value);
      const date = new Date(value);
      const yyyy = date.getFullYear();
      let mm: any = date.getMonth() + 1; // Months start at 0!
      let dd: any = date.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedToday = dd + "/" + mm + "/" + yyyy;
      return formattedToday;
    } else {
      return "-";
    }
  },
};
export const trimAssetName = (assetName: any) => {
  let trimmedAssetName = "-";
  if (assetName) {
    let stationName = assetName.split("_")[2];
    let splitNameFromIndex = assetName.indexOf(stationName) + stationName.length + 1;
    let deviceName = assetName.slice(splitNameFromIndex);
    trimmedAssetName = stationName + "-" + deviceName;
  }
  return trimmedAssetName;
};

export const extractFilters = (filter: any) => {
  return Object.keys(filter)
    .map((filterKey) => {
      if (filter[filterKey] === "") {
        return "";
      } else if (typeof filter[filterKey] === "number") {
        return `${filterKey}=${filter[filterKey]}`;
      } else if (filter[filterKey] === true || filter[filterKey] === false) {
        return `${filterKey}=${filter[filterKey]}`;
      } else if (Array.isArray(filter[filterKey])) {
        if (filter[filterKey].length > 0) {
          return `${filterKey}=${encodeURIComponent(filter[filterKey].join(","))}`;
        } else {
          return "";
        }
      } else {
        return filter[filterKey] ? `${filterKey}=${encodeURIComponent(filter[filterKey])}` : "";
      }
    })
    .filter((f) => !!f)
    .join("&");
};
